import { ApplicationState } from "store";
import { Reducer } from "redux";
import { PostData } from "burde";

enum ActionType {
    SetTemporaryCalendarId = "SET_TEMPORARY_CALENDAR_ID",
    SetUserHasChangedBorder = "SET_USER_HAS_CHANGED_BORDER",
    SetUserHasLeftOwnerPageStep = "SET_USER_HAS_LEFT_OWNER_PAGE_STEP",
}

interface SetTemporaryCalendarIdAction {
    type: ActionType.SetTemporaryCalendarId;
    temporaryCalendarId: string;
}

interface SetUserHasChangedBorderAction {
    type: ActionType.SetUserHasChangedBorder;
    userHasChangedBorder: boolean;
}

interface SetUserHasLeftOwnerPageStepAction {
    type: ActionType.SetUserHasLeftOwnerPageStep;
    userHasLeftOwnerPageStep: boolean;
}

type EventStateAction =
    | SetUserHasChangedBorderAction
    | SetTemporaryCalendarIdAction
    | SetUserHasLeftOwnerPageStepAction;

export const actionCreators = {
    updateTemporaryCalendarId: (temporaryCalendarId: string) =>
        <SetTemporaryCalendarIdAction>{
            type: ActionType.SetTemporaryCalendarId,
            temporaryCalendarId,
        },
    updateUserHasChangedBorder: (userHasChangedBorder: boolean) =>
        <SetUserHasChangedBorderAction>{
            type: ActionType.SetUserHasChangedBorder,
            userHasChangedBorder,
        },
    updateUserHasLeftOwnerPageStep: (userHasLeftOwnerPageStep: boolean) =>
        <SetUserHasLeftOwnerPageStepAction>{
            type: ActionType.SetUserHasLeftOwnerPageStep,
            userHasLeftOwnerPageStep,
        },
};

export type EventState = {
    temporaryCalendarId: string;
    userHasChangedBorder: boolean;
    userHasLeftOwnerPageStep: boolean;
    postData: PostData | null;
};

export const getTemporaryCalendarId = (state: ApplicationState) =>
    state.event.temporaryCalendarId;

export const getUserHasChangedBorder = (state: ApplicationState) =>
    state.event.userHasChangedBorder;

export const getUserHasLeftOwnerPageStep = (state: ApplicationState) =>
    state.event.userHasLeftOwnerPageStep;

export const getPostData = (state: ApplicationState) => state.event.postData;

export const initialState: EventState = {
    temporaryCalendarId: "",
    userHasChangedBorder: false,
    userHasLeftOwnerPageStep: false,
    postData: null,
};

export const reducer: Reducer<EventState, any> = (
    state: EventState = initialState,
    action: EventStateAction,
) => {
    if (action) {
        if (action.type === ActionType.SetUserHasChangedBorder) {
            return {
                ...state,
                userHasChangedBorder: action.userHasChangedBorder,
            };
        } else if (action.type === ActionType.SetTemporaryCalendarId) {
            return {
                ...state,
                temporaryCalendarId: action.temporaryCalendarId,
            };
        } else if (action.type === ActionType.SetUserHasLeftOwnerPageStep) {
            return {
                ...state,
                userHasLeftOwnerPageStep: action.userHasLeftOwnerPageStep,
            };
        }
    }

    return state;
};
